import { apiCall } from '../../context/api';

export const resetPassword = async (token, password, confirmPassword, base_url) => {
  return apiCall(base_url, null, 'POST', '/core/users/reset-password', {
    token,
    password,
    confirm_password: confirmPassword,
  });
};
